<template>
  <div class="mt-2">
    <div class="mb-2">
      <v-btn
        icon
        :to="{
          name: 'diario-escolar-aulas',
          params: {
            ano,
            cdturma,
            disciplina,
            tipoDeEnsino,
            cdinstruc,
            pagina,
            filtro,
            AEEouACP,
          },
        }"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert
      type="error"
      :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0"
      dark
      class="mb-3"
    >
      <div v-if="$v.$invalid && $v.$dirty">
        Preencha os campos corretamente.
      </div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-alert
      type="error"
      :value="showAlert"
    >
        Não é possível salvar aula futura com presença ou ausência para todos. Favor utilizar  o atalho Alt + G para salvar aula futura.
    </v-alert>

    <v-card>
      <v-toolbar color="blue" dark>
        <v-toolbar-title>{{
          id ? `Alterar Aula Número ${id}` : "Nova Aula"
        }}</v-toolbar-title>
      </v-toolbar>
      <div class="pa-3">
        <form @submit.prevent="onSubmit">
          <Select
            ref="periodoavaliativo"
            label="Período Avaliativo"
            v-model="form.cdpravadi"
            :v="$v.form.cdpravadi"
            :options="periodoAvaliativo"
          />
          <InputDate
            v-model="form.dataaula"
            label="Data da Aula"
            :v="$v.form.dataaula"
            max="10"
            @input="montarOptionAlunos"
          />
          <Input
            class="mt-3"
            type="text"
            v-model="form.descricaoassuntolecionado"
            label="Assunto Lecionado"
            :v="$v.form.descricaoassuntolecionado"
          />
          <MultipleSelect
            class="mt-4"
            label="Alunos"
            :options="optionsAlunos"
            :v="$v.alunosSelecionados"
            :disabled="form.dataaula === ''"
            @change="
              optionsAlunos = $event;
              alunosSelecionados = optionsAlunos.filter(
                (e) => e.selecionado === true
              );
            "
          />

          <TextArea
            v-model="form.descricaodesenvolvimentoaula"
            label="Desenvolvimento da aula"
            :v="$v.form.descricaodesenvolvimentoaula"
          />
          <TextArea
            class="mt-3"
            v-model="form.descricaorecursosutilizados"
            label="Recursos utilizados"
            :v="$v.form.descricaorecursosutilizados"
          />
          <TextArea
            class="mt-3"
            v-model="form.descricaoatividadeassociada"
            label="Atividade Associada"
            :v="$v.form.descricaoatividadeassociada"
          />
          <TextArea
            class="mt-3"
            v-model="form.descricaoobjetivo"
            label="Objetivo"
            :v="$v.form.descricaoobjetivo"
          />
          <Validator label="Aula presencial?" :v="$v.form.indicapresencial">
            <Radio
              arialabel="Aula presencial?"
              label="Sim"
              v-model="form.indicapresencial"
              val="S"
              :disabled="
                indicamodelodeaula === 'R' ||
                indicamodelodeaula === 'P' ||
                (this.id && indicamodelodeaula === 'H')
              "
            />
            <!-- Configuração do ano no modelo híbrido -->
            <Radio
              arialabel="Aula presencial?"
              label="Não"
              v-model="form.indicapresencial"
              val="N"
              :disabled="
                indicamodelodeaula === 'R' ||
                indicamodelodeaula === 'P' ||
                (this.id && indicamodelodeaula === 'H')
              "
            />
          </Validator>
          <Validator label="Reposição?" :v="$v.form.indicareposicao">
            <Radio
              arialabel="Reposição?"
              label="Sim"
              v-model="form.indicareposicao"
              val="S"
            />
            <Radio
              arialabel="Reposição?"
              label="Não"
              v-model="form.indicareposicao"
              val="N"
            />
          </Validator>
          <InputDate
            v-model="form.datareposicao"
            :disabled="form.indicareposicao === 'N'"
            label="Referente a data"
            :v="$v.form.datareposicao"
          />
          <Validator label="Situação" :v="$v.form.indicasituacao">
            <Radio
              arialabel="Situação"
              label="Elaboração"
              disabled
              v-model="form.indicasituacao"
              val="E"
            />
            <Radio
              arialabel="Situação"
              label="Exibida para o público"
              disabled
              v-model="form.indicasituacao"
              val="P"
            />
          </Validator>
          <TextArea
            label="Observação"
            v-model="form.descricaoobservacao"
            :v="$v.form.descricaoobservacao"
          />
          <!-- <Input v-if="!(this.id)" type="number" label="Quantos módulos/aula?" v-model="form.qtdModulosAula" :v="$v.form.qtdModulosAula" :min="1" :max="quantidadeMaxAulasPermitidas" /> -->
          <Validator
            label="Campos de experiência"
            block
            v-if="false"
            style="flex: 100%; margin-top: 20px"
          >
            <div>
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia1"
                :label="'Eu, o outro e o nós'"
                :val="form.indicacampoexperiencia1 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia2"
                :label="'Corpo, gestos e movimentos'"
                :val="form.indicacampoexperiencia2 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia3"
                :label="'Traços, sons, cores e formas'"
                :val="form.indicacampoexperiencia3 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia4"
                :label="'Escuta, fala, pensamento e imaginação'"
                :val="form.indicacampoexperiencia4 ? 'S' : 'N'"
              />
              <br />
              <CheckBoxCustom
                :trueValue="'S'"
                :falseValue="'N'"
                v-model="form.indicacampoexperiencia5"
                :label="'Espaços, tempos, quantidade, relações e transformações'"
                :val="form.indicacampoexperiencia5 ? 'S' : 'N'"
              />
            </div>
          </Validator>
          <div v-if="!this.id" style="display: flex; justify-content: flex-end">
            <v-btn
              v-if="!dataAulaFutura"
              :loading="loading"
              color="teal"
              class="button-copiar-ultima-aula rounded-sm font-weight-regular"
              dark
              style="height: 51px; margin-top: 8px; font-size: 13px;"
              @click="salvarComFrequencia"
              >Salvar aula e registrar presença para todos</v-btn
            >
          </div>
          <div v-if="!this.id" style="display: flex; justify-content: flex-end">
            <v-btn
              v-if="!dataAulaFutura"
              :loading="loading"
              color="teal"
              class="button-copiar-ultima-aula rounded-sm font-weight-regular"
              dark
              style="height: 51px; margin-top: 8px; font-size: 13px;"
              @click="salvarComAusencia"
              >Salvar aula e registrar ausência para todos</v-btn
            >
          </div>
          <div style="display: flex; justify-content: flex-end">
            <v-btn
              color="cyan"
              style="color: white"
              class="button-copiar-ultima-aula rounded-sm font-weight-regular mt-2"
              v-if="!id"
              :disabled="disabilitarBotaoCopiar"
              :loading="loadingCopiarAula"
              @click="getUltimaAula"
              >Copiar Última Aula</v-btn
            >
          </div>
          <div style="display: flex; justify-content: flex-end; gap: 5px; margin-top: 10px;">
            <Input
              v-if="!this.id"
              class="input-qtdmodulosaula"
              type="number"
              label="Quantos módulos/aula?"
              v-model="form.qtdModulosAula"
              :v="$v.form.qtdModulosAula"
              :min="1"
              :max="quantidadeMaxAulasPermitidas"
              style="width: 200px;"            />
            <v-btn
              class="rounded-sm font-weight-regular"
              type="submit"
              :loading="loading"
              color="teal"
              dark
              style="height: 51px; margin-top: 8px; width: 200px;"
            >
              <span v-if="!this.id">Salvar apenas a aula</span
              ><span v-else>Salvar</span>
            </v-btn>
          </div>
        </form>
      </div>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="4000"
      height="10px"
      rounded="0"
    >
      <div class="d-flex justify-space-between align-center">
        <span tabindex="0" class="snackbartext"> {{ submitText }}</span>
        <v-btn class="text-right" variant="text" icon @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import store from "@/store/index";
import {
  required,
  maxLength,
  integer,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";
import { alphaNumSpace, before } from "@/validations";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import parametros from "@/utils/parametros.js";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");
const PeriodoAvaliativoRepository = RepositoryFactory.get("periodoAvaliativo");
const diarioEscolarAEEeACP = RepositoryFactory.get("diarioEscolarAEEeACP");
const turma = RepositoryFactory.get("turma");
const DisciplinaDispensadaRepository = RepositoryFactory.get(
  "disciplinaDispensada"
);

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const setFormInicial = (props) => ({
  aaletivo: props.ano,
  ...dadosUser(),
  cdturma: props.cdturma,
  cdinstruc: props.cdinstruc,
  cddiscipl: props.disciplina,
  cdpravadi: "",
  dataaula: "",
  alunosDaTurma: [],
  alunosSelecionados: [],
  descricaoassuntolecionado: "",
  //identificadorplanejamento: '',
  descricaodesenvolvimentoaula: "",
  descricaorecursosutilizados: "",
  descricaoatividadeassociada: "",
  indicareposicao: "N",
  datareposicao: "",
  descricaoobservacao: "",
  indicasituacao: "E",
  descricaoobjetivo: "",
  tipoDeEnsino: props.tipoDeEnsino,
  indicacampoexperiencia1: "N",
  indicacampoexperiencia2: "N",
  indicacampoexperiencia3: "N",
  indicacampoexperiencia4: "N",
  indicacampoexperiencia5: "N",
  indicapresencial: "S",
  qtdModulosAula: 1,
});

function retornaIndicaPresencialInicial(indicamodelodeaula) {
  if (indicamodelodeaula === "P") return "S";
  else if (indicamodelodeaula === "R") return "N";
  else return "S";
}

export default {
  name: "AulaAEEouACPCadastro",
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    id: [Number, String],
    tipoDeEnsino: [String],
    cdinstruc: [Number],
    pagina: [Number],
    filtro: [Object],
    AEEouACP: [Boolean],
  },
  data() {
    return {
      showAlert: false,
      alunos: [],
      alunosDispensados: [],
      optionsAlunos: [],
      form: setFormInicial(this.$props),
      msgArrayError: [],
      periodoAvaliativo: [],
      snackbar: false,
      submitText: "",
      loading: false,
      loadingCopiarAula: false,
      disabilitarBotaoCopiar: true,
      qtdModulosAula: 1,
      quantidadeMaxAulasPermitidas: 0,
      indicamodelodeaula: "",
      alunosSelecionados: [],
      considerarFrequenciaOuAusencia: null,
    };
  },

  mounted() {
   document.addEventListener('keydown', this.onKeyDown);
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const { cdtipesc, cdescola } = dadosUser();
      const periodo = await PeriodoAvaliativoRepository.getPeriodoTurmas({
        aaletivo: to.params.ano,
        cdtipesc,
        cdescola,
        cdturma: to.params.cdturma,
        cdinstruc: to.params.cdinstruc,
      });
      const alunosDaTurma = await turma.getEnturmacao({
        aaletivo: to.params.ano,
        cdtipesc,
        cdescola,
        cdturma: to.params.cdturma,
      });

      const alunosDispensados =
        await DisciplinaDispensadaRepository.getAlunosDaTurmaDispensadosDaDisciplina(
          {
            aaletivo: to.params.ano,
            cdtipesc,
            cdescola,
            cdturma: to.params.cdturma,
            cddiscipl: to.params.disciplina,
          }
        );

      const tipoDeEnsino = to.params.tipoDeEnsino;
      const cdinstruc = to.params.cdinstruc;
      //const aaletivo = to.params.ano;
      const quantidadeMaxAulasPermitidas =
        parametros.getQuantidadeMaxAulasPermitidas("AEEouACP");
      const indicamodelodeaula =
        periodo.data.configuracaoAnoLetivo.indicamodelodeaula;
      let indicapresencial = "";
      let alunosDaAula = [];

      let listaDeAlunosSelecionados = [];

      let editar = {};
      if (to.params.id) {
        editar = await DiarioEscolarRepository.getAula(to.params.id);
        editar.data.results.cdinstruc = cdinstruc;

        alunosDaAula = await diarioEscolarAEEeACP.getListarAlunos(to.params.id);

        listaDeAlunosSelecionados = alunosDaAula.data.map(function (e) {
          return {
            key: e.numatalun,
            title: e.matricula.aluno.nmaluno,
            value: e.numatalun,
            selecionado: true,
            disabled: false,
            observacaoDesabilitado: "",
          };
        });
      }

      next((vm) => {
        vm.montarPeriodoAvaliativo(periodo.data.results);
        //
        if (to.params.id) {
          vm.load(editar.data.results);
        } else {
          indicapresencial = retornaIndicaPresencialInicial(indicamodelodeaula);
          vm.form.indicapresencial = indicapresencial;
        }

        vm.alunosDispensados = alunosDispensados.data.results;
        vm.tipoDeEnsino = tipoDeEnsino;
        vm.cdinstruc = cdinstruc;
        vm.quantidadeMaxAulasPermitidas = quantidadeMaxAulasPermitidas;
        vm.indicamodelodeaula = indicamodelodeaula;
        vm.alunos = alunosDaTurma.data.results;

        vm.form.alunosDaTurma = alunosDaTurma.data.results.map(function (e) {
          return {
            key: e.numatalun,
            value: e.numatalun,
            title: e.nmaluno,
            disabled: false,
            observacaoDesabilitado: "",
          };
        });
        vm.alunosSelecionados = listaDeAlunosSelecionados;
        vm.form.hoje = periodo.data.datahoje;

        const alunosDaTurmaComAtributoSelecionado = vm.form.alunosDaTurma.map(
          function (e) {
            if (
              listaDeAlunosSelecionados.find((element) => element.key === e.key)
            ) {
              return {
                key: e.key,
                value: e.value,
                title: e.title,
                selecionado: true,
                disabled: false,
                observacaoDesabilitado: "",
              };
            } else {
              return {
                key: e.key,
                value: e.value,
                title: e.title,
                selecionado: false,
                disabled: false,
                observacaoDesabilitado: "",
              };
            }
          }
        );
        vm.form.alunosDaTurma = alunosDaTurmaComAtributoSelecionado;

        vm.optionsAlunos = vm.form.alunosDaTurma;
      });
    } catch (e) {
      next("/diario-escolar");
    }
  },
  created() {
    this.$Progress.finish();
    setTimeout(() => this.$refs.periodoavaliativo.$refs.select.focus(), 200);
  },
  beforeUpdate() {
    if (this.id) {
      //console.log('beforeUpdate this.alunos =', this.alunos)
      this.montarOptionAlunos();
    }
  },
  watch: {
    "form.indicareposicao"(newVal, oldVal) {
      if (newVal === "N") {
        this.form.datareposicao = "";
      }
    },
  },
  computed: {
    dataAulaFutura() {
      const dataaula = moment(this.form.dataaula, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      const hoje = moment().format("YYYY-MM-DD");
      //return new Date(this.form.dataaula).getTime() > new Date(this.form.hoje).getTime()
      return new Date(dataaula).getTime() > new Date(hoje).getTime();
    },
  },
  validations() {
    return {
      alunosSelecionados: { required },
      form: {
        aaletivo: { required, integer, maxLength: maxLength(4) },
        cdtipesc: { required, integer },
        cdescola: { required, integer },
        cdpessoal: { required, integer },
        cdmatric: { required, integer },
        cdturma: { required, alphaNumSpace, maxLength: maxLength(4) },
        cddiscipl: { required, integer },
        cdpravadi: { required, alphaNumSpace },
        dataaula: {
          required,
          maxLength: maxLength(10),
          isValidDate: (value) => moment(value, "DD/MM/YYYY").isValid(),
        },
        descricaoassuntolecionado: { required, maxLength: maxLength(400) },
        //identificadorplanejamento: { },
        descricaodesenvolvimentoaula: { maxLength: maxLength(400) },
        descricaorecursosutilizados: { maxLength: maxLength(400) },
        descricaoatividadeassociada: { maxLength: maxLength(400) },
        descricaoobjetivo: { maxLength: maxLength(600) },
        indicareposicao: { required },
        datareposicao: {
          required: this.form.indicareposicao == "S" ? required : "",
          maxLength: maxLength(10),
          before: before(
            moment(this.form.dataaula, "DD/MM/YYYY").format("YYYY-MM-DD")
          ),
        },
        descricaoobservacao: { maxLength: maxLength(400) },
        indicasituacao: { required },
        indicacampoexperiencia1: { required },
        indicacampoexperiencia2: { required },
        indicacampoexperiencia3: { required },
        indicacampoexperiencia4: { required },
        indicacampoexperiencia5: { required },
        indicapresencial: { required },
        qtdModulosAula: {
          minValue: minValue(1),
          maxValue: maxValue(this.quantidadeMaxAulasPermitidas),
        },
        hoje: "",
      },
    };
  },
  methods: {
    onKeyDown(event) {
      this.showAlert = false;
      if (event.altKey && (event.key === 'p' || event.key === 'P' )) {
        if (!this.dataAulaFutura) {
          this.salvarComFrequencia();
        } else {
          this.showAlert = true;
        }
      }
      if (event.altKey && (event.key === 'a' || event.key === 'A')) {
        if (!this.dataAulaFutura) {
          this.salvarComAusencia();
        } else {
          this.showAlert = true;
        }
      }
      if (event.altKey && (event.key === 'g' || event.key === 'G')) {
          this.onSubmit();
      }         
    },
    selecionaAlunos(alunos) {
      // console.log($event)
      this.form.alunosSelecionados = alunos;
    },
    montarOptionAlunos() {
      // console.log('entrei aqui')
      this.optionsAlunos = [];

      for (let i = 0; i < this.alunos.length; i++) {
        let observacaoDesabilitado = "";
        // let cdsitfim = parseInt(this.alunos[i].cdsitfim)
        //let afastado = (cdsitfim === 6 || cdsitfim === 7 || cdsitfim === 8 || cdsitfim === 19 || cdsitfim === 23)
        let afastado = this.alunos[i].dtafastam !== null;
        // console.log('aluno =', this.alunos[i].nmaluno,' dtafastam =', this.alunos[i].dtafastam, ' afastado = ', afastado)
        let dataAula = new Date(
          moment(this.form.dataaula, "DD/MM/YYYY").format("YYYY-MM-DD")
        ).getTime();
        let dtafastam = new Date(this.alunos[i].dtafastam).getTime();
        let ativoNaDataDaAula = afastado ? dataAula < dtafastam : true;
        let disabled = ativoNaDataDaAula ? false : true;

        let selecionado = this.id
          ? this.alunosSelecionados.filter(
              (e) => e.key === this.alunos[i].numatalun
            ).length > 0
          : this.alunosSelecionados.indexOf(this.alunos[i]) >= 0;
        let dispensado =
          this.alunosDispensados.filter(
            (e) => e.numatalun === this.alunos[i].numatalun
          ).length > 0;

        if (dispensado) {
          disabled = true;
          observacaoDesabilitado = "DISPENSADO";
        } else if (disabled) {
          disabled = true;
          observacaoDesabilitado = this.alunos[i].situacaofinal;
        }

        this.optionsAlunos.push({
          key: this.alunos[i].numatalun,
          value: this.alunos[i].numatalun,
          title: this.alunos[i].nmaluno,
          selecionado: selecionado,
          disabled: disabled,
          observacaoDesabilitado: observacaoDesabilitado,
        });
      }
    },
    async salvarComFrequencia() {
      this.considerarFrequenciaOuAusencia = "P";
      this.onSubmit();
    },
    async salvarComAusencia() {
      this.considerarFrequenciaOuAusencia = "A";
      this.onSubmit();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
        return;
      }
      try {
        this.loading = true;
        this.msgArrayError = [];
        const alunosDaTurma = this.optionsAlunos;
        this.form.alunosDaTurma = alunosDaTurma;
        const funcao = this.id ? "put" : "post";
        const { data } = await DiarioEscolarRepository[`${funcao}Aula`]({
          ...this.form,
          dataaula: moment(this.form.dataaula, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          ),
          datareposicao: this.form.datareposicao
            ? moment(this.form.datareposicao, "DD/MM/YYYY").format("YYYY-MM-DD")
            : "",
          AEEouACP: this.AEEouACP,
          considerarFrequenciaOuAusencia: this.considerarFrequenciaOuAusencia,
        });

        this.submitText = data.message;
        this.snackbar = true;
        this.$nextTick(() => {          
          document.getElementsByClassName("snackbartext")[0].focus();          
        });

        const auxPeriodoAnterior = this.form.cdpravadi;
        this.form = setFormInicial(this.$props);
        this.form.cdpravadi = auxPeriodoAnterior;
        if (funcao === "post") {
          this.form.indicapresencial = retornaIndicaPresencialInicial(
            this.indicamodelodeaula
          );
        }
        this.$v.$reset();
        this.disabilitarBotaoCopiar = false;

        if (this.id) {
          this.$root.$router.push({
            name: "diario-escolar-aulas",
            params: {
              ano: this.ano,
              cdturma: this.cdturma,
              disciplina: this.disciplina,
              tipoDeEnsino: this.tipoDeEnsino,
              cdinstruc: this.cdinstruc,
              pagina: this.pagina,
              AEEouACP: this.AEEouACP,
              considerarFrequenciaOuAusencia:
                this.considerarFrequenciaOuAusencia,
            },
          });
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data.status == "ERROR_BUSINESS_RULE"
        ) {
          this.msgArrayError = error.response.data.errorMessage;
        }
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } finally {
        this.loading = false;
      }
    },
    montarPeriodoAvaliativo(data) {
      const formatedPeriodo = data.map((key) => ({
        value: key.cdpravadi,
        text: key.dspravadi,
      }));

      this.periodoAvaliativo = formatedPeriodo;
      if (data.length > 0) {
        this.form.cdpravadi = data[0].cdpravadi;
        for (let valor of data) {
          if (valor.aberto) {
            this.form.cdpravadi = valor.cdpravadi;
            break;
          }
        }
      }
    },
    load(data) {
      this.form = { ...data };
      this.form.dataaula = moment(data.dataaula, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
      this.form.datareposicao = moment(data.datareposicao, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
    },
    async getUltimaAula() {
      this.loadingCopiarAula = true;
      try {
        const { data } = await DiarioEscolarRepository.getAulasProfessor({
          ...dadosUser(),
          ultima: true,
          aaletivo: this.ano,
          cdturma: this.cdturma,
          cddiscipl: this.disciplina,
          tipoDeEnsino: this.tipoDeEnsino,
          cdinstruc: this.cdinstruc,
          AEEouACP: this.AEEouACP,
        });
        if (data.results.aulas.data.length > 0) {
          this.disabilitarBotaoCopiar = true;
          this.form = {
            ...data.results.aulas.data[0],
            identificadoraula: null,
            qtdModulosAula: 1,
            alunosDaTurma: this.form.alunosDaTurma,
            dataaula: moment(
              data.results.aulas.data[0].dataaula,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY"),
            datareposicao: data.results.aulas.data[0].datareposicao
              ? moment(
                  data.results.aulas.data[0].datareposicao,
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY")
              : "",
          };
          this.form.alunosDaTurma = this.alunosSelecionados =
            data.results.data[0].alunosSelecionados.map(function (e) {
              return {
                key: e.numatalun,
                selecionado: true,
                title: e.matricula.aluno.nmaluno,
                value: e.numatalun,
              };
            });
        }
      } catch (error) {
        /* throw error; */
      } finally {
        this.loadingCopiarAula = false;
      }
    },
  },
};
</script>

<style>
.snackbartext:focus {
  outline:none !important;
}
.input-qtdmodulosaula {
  width: 20%;
}

@media only screen and (max-width: 500px) {
  .input-qtdmodulosaula {
    width: 100%;
  }
}

.button-copiar-ultima-aula {
  width: 405px;
}

@media only screen and (max-width: 500px) {
  .button-copiar-ultima-aula {
    width: 100%;
  }
}
</style>
